import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class SpinnerService {

	constructor() { }

	private subject = new Subject<{ show: boolean, settings: any }>();
	public change = this.subject.asObservable().pipe(share());

	private current = {
		mode: "indeterminate",
		value: 0
	};

	block() {
		this.update(true, this.current);
	}

	unblock() {
		this.update(false, this.current);
	}

	private update(show, settings) {
		this.subject.next({ show, settings });
	}
}
